import{styled as i}from"@mui/material/styles";import m from"@mui/material/Box";const t=i(m)((({theme:i})=>({padding:i.spacing(4),paddingLeft:i.spacing(0)})));export{t as MUIBox};
//# sourceMappingURL=styles.js.map
